module.exports = __webpack_public_path__ + "img/75679.c7f18db7.svg";